import { LitElement, html, css } from 'lit';

/* global google */

export class GoogleMap extends LitElement {
  static properties = {
    apiKey: { type: String },
    lat: { type: Number },
    lng: { type: Number },
    zoom: { type: Number },
    markerIcn: { type: String }
  };

  static styles = css`
    #map-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    #map {
      width: 100%;
      height: 100%;
    }

    .center-marker {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 32px;
      height: 32px;
      background-image: url("https://cdn-webportal.airtelstream.net/website/nigeria/assets/images/icons/pin.png");
      background-size: contain;
      background-repeat: no-repeat;
      transform: translate(-50%, -100%);
      pointer-events: none;
      z-index: 10;
    }

    .search-box {
   position: absolute;
    top: 10px;
    left: 10px;
    width: 100%;
    z-index: 20;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 6px;
    background: white;
    border-radius: 4px;
    padding: 15px;
    max-width: 410px;
    box-sizing: border-box;
    }

    .search-box input {
       padding: 0.75rem;
      font-size: 16px;
      border: none;
      outline: none;
      background: #E7E7E7;
      border-radius: 6px;
      width: 100%;
          box-sizing: border-box;
             background-image: url('../assets/icons/search_icon.svg');
                 background-size: 23px;
    background-position: 96% center;
    background-repeat: no-repeat;

    }
  `;

  constructor() {
    super();
    this.apiKey = '';
    this.lat = 37.7749; // default to San Francisco
    this.lng = -122.4194;
    this.zoom = 12;
    this._map = null;
    this._geocoder = null;
    this._autocomplete = null;
  }

  firstUpdated() {
    if (!window.google?.maps) {
      this._loadGoogleMapsScript().then(() => this._initMap());
    } else {
      this._initMap();
    }
  }

  updated(changed) {
    if ((changed.has('lat') || changed.has('lng')) && this._map) {
      this._map.setCenter({ lat: this.lat, lng: this.lng });
    }
  }

  _loadGoogleMapsScript() {
    return new Promise((resolve, reject) => {
      const existingScript = document.querySelector('#google-maps-script');
      if (existingScript) return resolve();

      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  _initMap() {
    const mapEl = this.renderRoot.querySelector('#map');
    const inputEl = this.renderRoot.querySelector('#search-input');

    if (!mapEl) return;

    this._map = new google.maps.Map(mapEl, {
      center: { lat: this.lat, lng: this.lng },
      zoom: this.zoom,
      disableDefaultUI: true,
    });

    this._geocoder = new google.maps.Geocoder();

    google.maps.event.addListenerOnce(this._map, 'idle', () => this._emitCenter());
    this._map.addListener('idle', () => this._emitCenter());

    if (inputEl) {
      this._autocomplete = new google.maps.places.Autocomplete(inputEl, {
        types: ['geocode'],
      });

      this._autocomplete.addListener('place_changed', () => {
        const place = this._autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          const location = place.geometry.location;
          const lat = location.lat();
          const lng = location.lng();
          this.lat = lat;
          this.lng = lng;
          this._map.setCenter({ lat, lng });
        }
      });
    }
  }

  _emitCenter() {
    const center = this._map?.getCenter();
    if (!center || !this._geocoder) return;

    const lat = center.lat();
    const lng = center.lng();

    this._geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      const address = status === 'OK' && results[0] ? results[0].formatted_address : null;

      this.dispatchEvent(new CustomEvent('location-changed', {
        detail: { lat, lng, address },
        bubbles: true,
        composed: true,
      }));
    });
  }

  render() {
    return html`
      <div id="map-container">
        <div class="search-box">
          <input id="search-input" type="text" placeholder="Search for a location" />
        </div>
        <div id="map"></div>
        <div class="center-marker"></div>
      </div>
    `;
  }
}

customElements.define('google-map', GoogleMap);
